module.exports = __webpack_public_path__ + "img/faceOne2N.a85de14f.svg";